import { ACCESSIBLE_MUDULE_KEYS } from "../../../constants/enum";
import { AuthorizedRoute } from "../../../router/AuthorizedRoute";
import { COMPANY_ROUTE } from "./Companies.constants";
import { ManageSingleCompany } from "./ManageSingleCompany";

export const companyRoutes = [
    { path: `${COMPANY_ROUTE}`, exact: true, element: <AuthorizedRoute moduleIds={[ACCESSIBLE_MUDULE_KEYS.SHIFT]}><ManageSingleCompany /></AuthorizedRoute> },
    // { path: `${COMPANY_ROUTE}/manage`, exact: true, element: <ManageSingleCompany /> },
    // { path: `${COMPANY_ROUTE}/manage/:uuid`, exact: true, element: <ManageSingleCompany /> },
]